import { render, staticRenderFns } from "./NewVisitaModal.vue?vue&type=template&id=c98c5864&"
import script from "./NewVisitaModal.vue?vue&type=script&lang=js&"
export * from "./NewVisitaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports